import { render, staticRenderFns } from "./WordSearchTester.vue?vue&type=template&id=55018496&scoped=true"
import script from "./WordSearchTester.vue?vue&type=script&setup=true&lang=ts"
export * from "./WordSearchTester.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WordSearchTester.vue?vue&type=style&index=0&id=55018496&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55018496",
  null
  
)

export default component.exports